/**
 * @generated SignedSource<<b8062b792d3e7eb6a423e1658a8f0520>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportsTable_company$data = {
  readonly id: string;
  readonly " $fragmentType": "ReportsTable_company";
};
export type ReportsTable_company$key = {
  readonly " $data"?: ReportsTable_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportsTable_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportsTable_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "a6dfa5576852c904ad5d3434ddbe3e9c";

export default node;
